/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { fetchTrustAccountData } from '../../../../../api/trust';
import * as handlers from '../../../../../utils/handlers';
import { TRUST_CONTRACT_TYPE_TA } from '../../../../../utils/types';

const ListOfContractsRow = ({
  rowData,
  id,
  setShowTable,
  showTable,
  agreementId,
  selectedAgreementID,
  trustStatus,
  contractType,
  inProgressStatus,
  disabled,
  getUpdatedTableData,
}) => {
  const filterData = useSelector((state) => state.filters.filters);
  const { contractNumber, status } = rowData;
  const { name, rgb } = trustStatus || {};
  const scrollView = () => {
    if (disabled === false) {
      document
        .querySelector('.contractDetails-section')
        .scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const handleViewDetail = () => {
    const isCancelledContract = status?.toLowerCase() === 'cancelled';

    setShowTable((data) => {
      return {
        ...data,
        agreementId,
        isCancelledContract,
      };
    });
  };
  const handleRefresh = async () => {
    const requestParams = {
      ...filterData,
      contractType: showTable.contractType,
      needType: showTable.needType,
      trustType: showTable.trustType,
      search: agreementId,
    };
    try {
      if (selectedAgreementID === agreementId)
        setShowTable((data) => {
          return {
            ...data,
            agreementId: undefined,
          };
        });
      const result = await fetchTrustAccountData(requestParams);
      if (result.data.status === 200) {
        getUpdatedTableData('pagination');

        if (selectedAgreementID === agreementId) {
          handleViewDetail();
        }
      } else {
        const err = new Error('Something went wrong. Please try again!');
        handlers.apiErrorHandler(err);
      }
    } catch (error) {
      handlers.apiErrorHandler(error);
    }
  };
  const wrapperFunc = async () => {
    await handleViewDetail();
    setTimeout(() => {
      scrollView();
    }, 1000);
  };

  return (
    <tr key={id} className="table-body-row">
      <td>{id}</td>
      <td>{contractNumber}</td>
      <td style={{ color: rgb }}>{name}</td>
      {inProgressStatus?.length && contractType === TRUST_CONTRACT_TYPE_TA ? (
        <td>{inProgressStatus}</td>
      ) : null}
      <td>
        <button type="button" className="view-details" disabled={disabled} onClick={wrapperFunc}>
          View Details
        </button>
      </td>
      <td>
        <button type="button" className="view-details" disabled={disabled} onClick={handleRefresh}>
          Refresh
        </button>
      </td>
    </tr>
  );
};
ListOfContractsRow.propTypes = {
  rowData: PropTypes.shape({
    contractNumber: PropTypes.string,
    status: PropTypes.string,
    inProgressStatus: PropTypes.string,
  }).isRequired,
  trustStatus: PropTypes.shape({
    name: PropTypes.string,
    rgb: PropTypes.string,
  }),
  id: PropTypes.number.isRequired,
  agreementId: PropTypes.number,
  contractType: PropTypes.string,
};
export default ListOfContractsRow;
